import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import emailjs from 'emailjs-com';
import ReCAPTCHA from 'react-google-recaptcha';

const Container = styled.div`
    background-color: #1d1d30;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    background-position: center center;
    background-repeat: repeat;
    background-attachment: fixed;
    height: 100vh;
    background-size: cover;
    background-color: #1d1d30;
    &.loaded{
        background-image: url("data:image/svg+xml;utf8,%3Csvg viewBox=%220 0 2000 1400%22 xmlns=%22http:%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cmask id=%22b%22 x=%220%22 y=%220%22 width=%222000%22 height=%221400%22%3E%3Cpath fill=%22url(%23a)%22 d=%22M0 0h2000v1400H0z%22%2F%3E%3C%2Fmask%3E%3Cpath fill=%22rgba(17%2C18%2C21%2C1)%22 d=%22M0 0h2000v1400H0z%22%2F%3E%3Cg style=%22transform-origin:center center%22 clip-rule=%22evenodd%22 stroke=%22%232e314a%22 stroke-width=%222.4%22 mask=%22url(%23b)%22%3E%3Cg fill-rule=%22evenodd%22%3E%3Cpath d=%22M600 116.586v230.667l199.99 115.343V231.929L600 116.586Z%22 fill=%22%232e314a0b%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22M799.99 462.596 1000 347.253V116.586L799.99 231.93v230.667Z%22 fill=%22%232e314a08%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22M600 116.586 799.99 1.263 1000 116.586 799.99 231.93 600 116.586Z%22 fill=%22%232e314a04%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill=%22none%22%3E%3Cpath d=%22M2200 116.586v230.667l199.99 115.343V231.929L2200 116.586ZM2399.99 462.596 2600 347.253V116.586L2399.99 231.93v230.667Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22M2200 116.586 2399.99 1.263 2600 116.586 2399.99 231.93 2200 116.586Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill=%22none%22%3E%3Cpath d=%22M3000 116.586v230.667l199.99 115.343V231.929L3000 116.586ZM3199.99 462.596 3400 347.253V116.586L3199.99 231.93v230.667Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22M3000 116.586 3199.99 1.263 3400 116.586 3199.99 231.93 3000 116.586Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill-rule=%22evenodd%22%3E%3Cpath d=%22M1600 463.253V693.92l199.99 115.343V578.596L1600 463.253Z%22 fill=%22%232e314ae4%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22M1799.99 809.263 2000 693.92V463.253l-200.01 115.343v230.667Z%22 fill=%22%232e314aa0%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m1600 463.253 199.99-115.323L2000 463.253l-200.01 115.343L1600 463.253Z%22 fill=%22%232e314a50%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill-rule=%22evenodd%22%3E%3Cpath d=%22M3200 463.253V693.92l199.99 115.343V578.596L3200 463.253Z%22 fill=%22%232e314a88%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22M3399.99 809.263 3600 693.92V463.253l-200.01 115.343v230.667Z%22 fill=%22%232e314a5f%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m3200 463.253 199.99-115.323L3600 463.253l-200.01 115.343L3200 463.253Z%22 fill=%22%232e314a30%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill=%22none%22%3E%3Cpath d=%22M2600 809.92v230.667l199.99 115.342V925.263L2600 809.92ZM2799.99 1155.93 3000 1040.586V809.92l-200.01 115.343v230.666Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m2600 809.92 199.99-115.324L3000 809.92l-200.01 115.344L2600 809.919Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill=%22none%22%3E%3Cpath d=%22M3000 809.92v230.667l199.99 115.342V925.263L3000 809.92ZM3199.99 1155.93 3400 1040.586V809.92l-200.01 115.343v230.666Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m3000 809.92 199.99-115.324L3400 809.92l-200.01 115.344L3000 809.919Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill=%22none%22%3E%3Cpath d=%22M400 1156.586v230.667l199.99 115.343v-230.667L400 1156.586ZM599.99 1502.596 800 1387.253v-230.667L599.99 1271.93v230.667Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m400 1156.586 199.99-115.323L800 1156.586 599.99 1271.93 400 1156.586Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill-rule=%22evenodd%22%3E%3Cpath d=%22M2800 1156.586v230.667l199.99 115.343v-230.667L2800 1156.586Z%22 fill=%22%232e314abe%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22M2999.99 1502.596 3200 1387.253v-230.667l-200.01 115.343v230.667Z%22 fill=%22%232e314a85%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m2800 1156.586 199.99-115.323L3200 1156.586l-200.01 115.343L2800 1156.586Z%22 fill=%22%232e314a42%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill=%22none%22%3E%3Cpath d=%22M3200 1156.586v230.667l199.99 115.343v-230.667L3200 1156.586ZM3399.99 1502.596 3600 1387.253v-230.667l-200.01 115.343v230.667Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m3200 1156.586 199.99-115.323L3600 1156.586l-200.01 115.343L3200 1156.586Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill-rule=%22evenodd%22%3E%3Cpath d=%22M1000 1503.253v230.667l199.99 115.343v-230.667L1000 1503.253Z%22 fill=%22%232e314a5e%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22M1199.99 1849.263 1400 1733.92v-230.667l-200.01 115.343v230.667Z%22 fill=%22%232e314a42%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m1000 1503.253 199.99-115.323L1400 1503.253l-200.01 115.343L1000 1503.253Z%22 fill=%22%232e314a21%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill=%22none%22%3E%3Cpath d=%22M800 1849.92v230.667l199.99 115.342v-230.666L800 1849.92ZM999.99 2195.93 1200 2080.586V1849.92l-200.01 115.343v230.666Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m800 1849.92 199.99-115.324L1200 1849.92l-200.01 115.344L800 1849.919Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill=%22none%22%3E%3Cpath d=%22M2800 1849.92v230.667l199.99 115.342v-230.666L2800 1849.92ZM2999.99 2195.93 3200 2080.586V1849.92l-200.01 115.343v230.666Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m2800 1849.92 199.99-115.324L3200 1849.92l-200.01 115.344L2800 1849.919Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill=%22none%22%3E%3Cpath d=%22M3600 1849.92v230.667l199.99 115.342v-230.666L3600 1849.92ZM3799.99 2195.93 4000 2080.586V1849.92l-200.01 115.343v230.666Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m3600 1849.92 199.99-115.324L4000 1849.92l-200.01 115.344L3600 1849.919Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill=%22none%22%3E%3Cpath d=%22M600 2196.586v230.667l199.99 115.343v-230.667L600 2196.586ZM799.99 2542.596 1000 2427.253v-230.667L799.99 2311.93v230.667Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m600 2196.586 199.99-115.323L1000 2196.586 799.99 2311.93 600 2196.586Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill=%22none%22%3E%3Cpath d=%22M2600 2196.586v230.667l199.99 115.343v-230.667L2600 2196.586ZM2799.99 2542.596 3000 2427.253v-230.667l-200.01 115.343v230.667Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m2600 2196.586 199.99-115.323L3000 2196.586l-200.01 115.343L2600 2196.586Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill=%22none%22%3E%3Cpath d=%22M3000 2196.586v230.667l199.99 115.343v-230.667L3000 2196.586ZM3199.99 2542.596 3400 2427.253v-230.667l-200.01 115.343v230.667Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m3000 2196.586 199.99-115.323L3400 2196.586l-200.01 115.343L3000 2196.586Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill-rule=%22evenodd%22%3E%3Cpath d=%22M3800 2196.586v230.667l199.99 115.343v-230.667L3800 2196.586Z%22 fill=%22%232e314a0c%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22M3999.99 2542.596 4200 2427.253v-230.667l-200.01 115.343v230.667Z%22 fill=%22%232e314a08%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m3800 2196.586 199.99-115.323L4200 2196.586l-200.01 115.343L3800 2196.586Z%22 fill=%22%232e314a04%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill=%22none%22%3E%3Cpath d=%22M800 2543.253v230.667l199.99 115.343v-230.667L800 2543.253ZM999.99 2889.263 1200 2773.92v-230.667l-200.01 115.343v230.667Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m800 2543.253 199.99-115.323L1200 2543.253l-200.01 115.343L800 2543.253Z%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill-rule=%22evenodd%22%3E%3Cpath d=%22M600 2889.92v230.667l199.99 115.342v-230.666L600 2889.92Z%22 fill=%22%232e314a24%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22M799.99 3235.93 1000 3120.586V2889.92l-200.01 115.343v230.666Z%22 fill=%22%232e314a19%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m600 2889.92 199.99-115.324L1000 2889.92l-200.01 115.344L600 2889.919Z%22 fill=%22%232e314a0d%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3Cg fill-rule=%22evenodd%22%3E%3Cpath d=%22M2200 2889.92v230.667l199.99 115.342v-230.666L2200 2889.92Z%22 fill=%22%232e314aad%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22M2399.99 3235.93 2600 3120.586V2889.92l-200.01 115.343v230.666Z%22 fill=%22%232e314a79%22 stroke-width=%223.1999919999999995%22%2F%3E%3Cpath d=%22m2200 2889.92 199.99-115.324L2600 2889.92l-200.01 115.344L2200 2889.919Z%22 fill=%22%232e314a3c%22 stroke-width=%223.1999919999999995%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3Cdefs%3E%3CradialGradient id=%22a%22%3E%3Cstop offset=%2271.2%25%22 stop-color=%22%23fff%22 stop-opacity=%220%22%2F%3E%3Cstop offset=%22100%25%22 stop-color=%22%23fff%22 stop-opacity=%22.288%22%2F%3E%3C%2FradialGradient%3E%3C%2Fdefs%3E%3C%2Fsvg%3E");

    }
`;

const FormWrapper = styled.section`
    width: 80%;
    max-width: 650px;
    margin: 0 auto;
    .title {
        text-align: center;
        font-family: 'IBM Plex Sans', sans-serif;
        text-transform: uppercase;
        letter-spacing: 3px;
        font-size: 36px;
        margin-bottom: 48px;
        color: #c9c7c6;
    }

    @media (min-width: 800px) {
        width: 50%;
    }
`;

const StyledForm = styled.form`
    .form-field {
        position: relative;
        margin: 32px 0;
    }

    .submit-btn {
        display: inline-block;
        color: #c9c7c6;
        font-family: 'IBM Plex Sans', sans-serif;
        text-transform: uppercase;
        letter-spacing: 2px;
        font-size: 16px;
        padding: 8px 16px;
        background-color: #343955;
        border: none;
        cursor: pointer;
        border-radius: 3px;
        transition: all 200ms;
        :hover {
            box-shadow: 0px 0px 11px 0px rgba(255, 255, 255, 0.39);
        }
    }
`;

const Input = styled.input`
    display: block;
    width: 100%;
    border: none;
    color: #c9c7c6;
    border-bottom: 2px solid #000;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 18px;
    height: 36px;
    background: rgba(255, 255, 255, 0.15);
    box-shadow: 0 5px 50px 0 rgba(31, 38, 135, 0.1);
    backdrop-filter: blur(18px);
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-color: #4B527B;
    
    &:focus {
        outline: none;
    }

    &:focus + label,
    &:not(:placeholder-shown) + label {
        color: #c9c7c6;
        transform: translateY(-35px);
    }
`;

const Label = styled.label`
    position: absolute;
    left: 5px;
    bottom: 10px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 18px;
    color: #888;
    transition: transform 0.2s ease-in-out;
    pointer-events: none;
`;

const Textarea = styled.textarea`
    display: block;
    width: 100%;
    height: 100px;
    border: none;
    border-bottom: 2px solid #000;
    font-family: 'IBM Plex Sans', sans-serif;
    color: #c9c7c6;
    background: rgba(255, 255, 255, 0.15);
    box-shadow: 0 5px 50px 0 rgba(31, 38, 135, 0.1);
    backdrop-filter: blur(18px);
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-color: #4B527B;
    font-size: 18px;

    &:focus {
        outline: none;
    }
    &:focus + label,
    &:not(:placeholder-shown) + label {
        top: -24px;
        color: #c9c7c6;
    }
`;

const Label2 = styled.label`
    position: absolute;
    left: 5px;
    top: 8px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 18px;
    color: #888;
    transition: 0.2s ease-in-out;
    pointer-events: none;
`;

const FormField = styled.div`
    position: relative;
    margin: 32px 0;
`;

// Campo fake para atrapar bots
const Fakefield = styled.input`
    position: absolute;
    left: -9999px;
    top: -9999px;
`;

// Spinner de carga
const Spinner = styled.div`
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top: 4px solid #fff;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    animation: spin 1s linear infinite;
    margin: 0 auto;

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

const ContactMe = () => {
    const formRef = useRef();
    const [isCaptchaValid, setIsCaptchaValid] = useState(false);
    const [isLoading, setIsLoading] = useState(false); // Estado para el spinner

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!isCaptchaValid) {
            alert('Por favor, verifica que no eres un robot.');
            return;
        }

        // Verifica si el campo fake está vacío
        if (formRef.current.fakefield.value) {
            console.warn('Formulario bloqueado por posible intento de spam');
            return;
        }

        setIsLoading(true); // Muestra el spinner al iniciar el envío

        emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);

        emailjs.sendForm(
            process.env.REACT_APP_EMAILJS_SERVICE_ID,
            process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
            formRef.current
        )
            .then(() => {
                alert('Correo enviado con éxito!');
                formRef.current.reset();
                setIsCaptchaValid(false);
            })
            .catch((error) => {
                console.error('Error al enviar el correo:', error);
                alert('Hubo un error al enviar el correo. Inténtalo de nuevo.');
            })
            .finally(() => {
                setIsLoading(false); // Oculta el spinner al finalizar
            });
    };

    const handleCaptchaChange = (value) => {
        setIsCaptchaValid(!!value);
    };

    const contenedorRef = useRef(null);

    useEffect(() => {
        // Cargar el fondo SVG después de que la página se haya renderizado
        const timer = setTimeout(() => {
            contenedorRef.current.classList.add("loaded");
        }, 500); // Retraso opcional para cargar el SVG
        return () => clearTimeout(timer);
    }, []);

    return (
        <Container ref={contenedorRef}>
            <FormWrapper>
                <h1 className="title">Get in touch</h1>
                <StyledForm ref={formRef} onSubmit={handleSubmit} autoComplete="off">
                    <Fakefield type="text" name="fakefield" autoComplete="off" />

                    <FormField className="form-field">
                        <Input id="name" autoComplete="off" type="text" name="user_name" placeholder=" " required />
                        <Label htmlFor="name">Name</Label>
                    </FormField>
                    <FormField className="form-field">
                        <Input id="email" autoComplete="off" type="email" name="user_email" placeholder=" " required />
                        <Label htmlFor="email">E-mail</Label>
                    </FormField>
                    <FormField className="form-field">
                        <Textarea id="message" name="message" placeholder=" " required></Textarea>
                        <Label2 htmlFor="message">Message</Label2>
                    </FormField>
                    <ReCAPTCHA
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                        onChange={handleCaptchaChange}
                    />
                    <div className="form-field">
                        {isLoading ? (
                            <Spinner /> // Muestra el spinner si está cargando
                        ) : (
                            <input className="submit-btn" type="submit" value="Submit" disabled={!isCaptchaValid} />
                        )}
                    </div>
                </StyledForm>
            </FormWrapper>
        </Container>
    );
};
export default ContactMe;
